const UOM_PRIORITY: readonly string[] = ["usd_bbl", "usc_bbl", "usd_ton", "usd_gal", "usc_gal"];

export type UomRow = { value: string; description?: string | null };

export type UomOption = { value: string; label: string; groupValue: string };

/** Builds the UoM list: the common UoMs first, then the rest A-Z. */
export function makeUomOptions(uomList: readonly UomRow[]): UomOption[] {
  const options = uomList
    .map((uom) => ({
      value: uom.value,
      label: uom.description ?? uom.value,
      groupValue: "",
    }))
    // Some environments have blank UoM rows, which render as an empty and
    // unselectable menu item (WEB-1951).
    .filter((opt) => opt.value.trim() !== "" && opt.label.trim() !== "");

  const prioritySet = new Set(UOM_PRIORITY);
  const priority: UomOption[] = [];
  const rest: UomOption[] = [];

  for (const opt of options) {
    if (prioritySet.has(opt.value)) {
      priority.push(opt);
    } else {
      rest.push(opt);
    }
  }

  priority.sort((a, b) => UOM_PRIORITY.indexOf(a.value) - UOM_PRIORITY.indexOf(b.value));

  rest.sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: "base" }));

  return [...priority, ...rest];
}
